import { createSelector } from '@ngrx/store';
import { selectCurrentAttachments } from './attachments.selector';
import { selectCurrentNote } from './current-note.selector';

export const selectPreview = createSelector(
  selectCurrentAttachments,
  selectCurrentNote,
  (attachments, note) => {
    let preview;

    if(note.role == 'screencast' || note.role == 'video' || note.role == 'streaming_video') {
      preview = attachments[0];
    } else if(note && note.preview  && note.preview.attachmentGlobalId) {
      preview = attachments.find((attachment) => attachment.globalId == note.preview.attachmentGlobalId)
    }

    return preview;
  }
);
